import html2canvas from 'html2canvas';
import { alpha } from '@mui/material';
import {
  TrendingUp,
  Compress,
  Shield,
  Warning,
  ShowChart,
  Bolt,
  CheckCircle,
  Block,
  History,
} from '@mui/icons-material';
import { behaviorAPI } from '../../services/api';

export const LABEL_META = {
  ACTIVE_MARKUP: { color: '#10b981', bg: '#ecfdf5', gradient: 'linear-gradient(135deg, #059669 0%, #10b981 100%)', icon: <TrendingUp /> },
  COILING_FOR_MARKUP: { color: '#3b82f6', bg: '#eff6ff', gradient: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)', icon: <Compress /> },
  SUPPORT_DEFENSE: { color: '#f59e0b', bg: '#fffbeb', gradient: 'linear-gradient(135deg, #d97706 0%, #f59e0b 100%)', icon: <Shield /> },
  FAKE_SUPPORT_OR_EXIT: { color: '#ef4444', bg: '#fef2f2', gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)', icon: <Warning /> },
  NEUTRAL: { color: '#94a3b8', bg: '#f8fafc', gradient: 'linear-gradient(135deg, #64748b 0%, #94a3b8 100%)', icon: <ShowChart /> },
};

export const ACTION_META = {
  ACTIONABLE: { color: '#10b981', icon: <Bolt sx={{ fontSize: 14 }} /> },
  WATCH_READY: { color: '#3b82f6', icon: <CheckCircle sx={{ fontSize: 14 }} /> },
  EARLY_WATCH: { color: '#f59e0b', icon: <Shield sx={{ fontSize: 14 }} /> },
  AVOID: { color: '#ef4444', icon: <Block sx={{ fontSize: 14 }} /> },
  IGNORE: { color: '#94a3b8', icon: null },
};

export const MONEY_FLOW_META = {
  good: { color: '#10b981', bg: '#ecfdf5' },
  neutral: { color: '#94a3b8', bg: '#f8fafc' },
  weak: { color: '#ef4444', bg: '#fef2f2' },
};

const CONVICTION_BAND_META = {
  ultra: {
    positive: { label: 'Rất mạnh', color: '#10b981' },
    negative: { label: 'Rất yếu', color: '#ef4444' },
  },
  strong: {
    positive: { label: 'Mạnh', color: '#22c55e' },
    negative: { label: 'Yếu', color: '#f97316' },
  },
  moderate: {
    positive: { label: 'Khá', color: '#3b82f6' },
    negative: { label: 'Hơi yếu', color: '#f59e0b' },
  },
  neutral: {
    positive: { label: 'Trung bình', color: '#94a3b8' },
    negative: { label: 'Trung bình', color: '#94a3b8' },
  },
};

export const WATCH_PRIORITY_META = {
  high: { labelKey: 'behavior.watchlist.priorityBands.high', color: '#10b981' },
  mid: { labelKey: 'behavior.watchlist.priorityBands.mid', color: '#2563eb' },
  low: { labelKey: 'behavior.watchlist.priorityBands.low', color: '#d97706' },
};

export const WATCH_CONVICTION_META = {
  high: { labelKey: 'behavior.watchlist.convictionBands.high', color: '#10b981' },
  mid: { labelKey: 'behavior.watchlist.convictionBands.mid', color: '#2563eb' },
  early: { labelKey: 'behavior.watchlist.convictionBands.early', color: '#0ea5e9' },
  low: { labelKey: 'behavior.watchlist.convictionBands.low', color: '#94a3b8' },
};

export const WATCH_STRENGTH_META = {
  watch: { labelKey: 'behavior.watchlist.strengthBands.watch', color: '#0891b2' },
  rest: { labelKey: 'behavior.watchlist.strengthBands.rest', color: '#64748b' },
  emerging: { labelKey: 'behavior.watchlist.strengthBands.emerging', color: '#7c3aed' },
  leader: { labelKey: 'behavior.watchlist.strengthBands.leader', color: '#2563eb' },
};

export const WATCH_ENTRY_META = {
  fast: { labelKey: 'behavior.watchlist.entryBands.fast', color: '#10b981' },
  building: { labelKey: 'behavior.watchlist.entryBands.building', color: '#2563eb' },
  early: { labelKey: 'behavior.watchlist.entryBands.early', color: '#0ea5e9' },
  flat: { labelKey: 'behavior.watchlist.entryBands.flat', color: '#94a3b8' },
};

export const WATCH_SUMMARY_ICON = {
  high: CheckCircle,
  mid: History,
  low: Shield,
};

export const WATCH_SUMMARY_META = {
  high: { labelKey: 'behavior.watchlist.summary.high', descKey: 'behavior.watchlist.summary.highDesc', color: '#10b981' },
  mid: { labelKey: 'behavior.watchlist.summary.mid', descKey: 'behavior.watchlist.summary.midDesc', color: '#3b82f6' },
  low: { labelKey: 'behavior.watchlist.summary.low', descKey: 'behavior.watchlist.summary.lowDesc', color: '#f59e0b' },
};

export const thSx = {
  fontSize: '0.68rem', fontWeight: 700, color: '#64748b',
  letterSpacing: '0.04em', textTransform: 'uppercase', py: 1, px: 1.5,
  borderBottom: '2px solid #e2e8f0', bgcolor: '#f8fafc',
  whiteSpace: 'nowrap', lineHeight: 1.4,
};

export const tdSx = {
  py: 0.7, px: 1.5, fontSize: '0.78rem',
  borderBottom: '1px solid #f1f5f9',
};

export const tableColSx = {
  index: { width: 42, minWidth: 42 },
  ticker: { minWidth: 230, width: 230 },
  price: { minWidth: 110, width: 110 },
  behavior: { minWidth: 160, width: 160 },
  action: { minWidth: 140, width: 140 },
  conviction: { minWidth: 110, width: 110 },
  score: { minWidth: 92, width: 92 },
  phase: { minWidth: 90, width: 90 },
  strength: { minWidth: 120, width: 120 },
  smartMoney: { minWidth: 120, width: 120 },
  moneyFlow: { minWidth: 110, width: 110 },
  sector: { minWidth: 130, width: 130 },
};

export const watchlistThSx = {
  ...thSx,
  py: 0.85,
  px: 1.2,
  fontSize: '0.72rem',
  color: '#94a3b8',
  borderBottom: '1px solid #e2e8f0',
  bgcolor: '#fafbfc',
};

export const watchlistTdSx = {
  ...tdSx,
  py: 0.95,
  px: 1.2,
};

export const SKEL_GRADIENTS = [
  'linear-gradient(135deg, #059669 0%, #10b981 100%)',
  'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
  'linear-gradient(135deg, #d97706 0%, #f59e0b 100%)',
  'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
];

export const TABLE_HEADER_SKELETONS = [
  { key: 'index', width: 24 },
  { key: 'ticker', width: 48 },
  { key: 'price', width: 44 },
  { key: 'behavior', width: 60 },
  { key: 'action', width: 64 },
  { key: 'conviction', width: 72 },
  { key: 'support', width: 60 },
  { key: 'coil', width: 48 },
  { key: 'markup', width: 56 },
  { key: 'distribution', width: 76 },
  { key: 'phase', width: 48 },
  { key: 'strength', width: 60 },
  { key: 'smart-money', width: 72 },
  { key: 'sector', width: 56 },
];

export const TABLE_ROW_SKELETON_KEYS = [
  'row-1', 'row-2', 'row-3', 'row-4', 'row-5', 'row-6',
  'row-7', 'row-8', 'row-9', 'row-10', 'row-11', 'row-12',
];

export const TRANSITION_FAVORABLE_LABELS = new Set(['ACTIVE_MARKUP', 'COILING_FOR_MARKUP', 'SUPPORT_DEFENSE']);
export const HISTORY_CHART_LEGEND_ORDER = ['ACTIVE_MARKUP', 'COILING_FOR_MARKUP', 'SUPPORT_DEFENSE', 'FAKE_SUPPORT_OR_EXIT', 'NEUTRAL'];

export const fmtDec = (n, d = 1) => {
  if (n == null) return '—';
  return Number(n).toFixed(d);
};

export const getMoneyFlowKey = (value) => String(value || '').toLowerCase();
export const getMoneyFlowMeta = (value) => MONEY_FLOW_META[getMoneyFlowKey(value)] || MONEY_FLOW_META.neutral;

export const getPriceChangeColor = (changePct = 0) => {
  if (changePct > 0) return '#10b981';
  if (changePct < 0) return '#ef4444';
  return '#94a3b8';
};

export const formatCompactVolume = (value) => {
  if (value == null) return '—';
  if (value >= 1e6) return `${(value / 1e6).toFixed(2)}M`;
  if (value >= 1e3) return `${(value / 1e3).toFixed(0)}K`;
  return String(value);
};

export const getLiquidityKey = (valueRatio) => {
  if (valueRatio == null) return null;
  if (valueRatio >= 1.5) return 'liqHigh';
  if (valueRatio >= 0.7) return 'liqNormal';
  return 'liqLow';
};

export const getLiquidityColor = (liqKey) => {
  if (liqKey === 'liqHigh') return '#10b981';
  if (liqKey === 'liqLow') return '#f59e0b';
  return '#64748b';
};

export const getRiskChipColors = (riskLabel) => {
  if (riskLabel === 'HIGH') return { bg: '#ef4444', text: '#991b1b' };
  if (riskLabel === 'LOW') return { bg: '#10b981', text: '#065f46' };
  return { bg: '#f59e0b', text: '#92400e' };
};

export const getConvictionBandKey = (absValue) => {
  if (absValue >= 35) return 'ultra';
  if (absValue >= 20) return 'strong';
  if (absValue >= 10) return 'moderate';
  return 'neutral';
};

export const getConvictionMeta = (absValue, isPositive) => {
  const bandKey = getConvictionBandKey(absValue);
  return CONVICTION_BAND_META[bandKey][isPositive ? 'positive' : 'negative'];
};

export const convStrength = (v) => {
  if (v == null) return { label: '—', color: '#94a3b8', pct: 0 };
  const abs = Math.abs(v);
  const meta = getConvictionMeta(abs, v > 0);
  const pct = abs >= 35 ? Math.min(abs, 50) / 50 : abs / 50;
  return { label: meta.label, color: meta.color, pct };
};

export const convArrows = (delta) => {
  if (delta == null) return null;
  const abs = Math.abs(delta);
  if (abs < 3) return null;
  const arrow = delta > 0 ? '↑' : '↓';
  if (abs >= 15) return arrow.repeat(3);
  if (abs >= 8) return arrow.repeat(2);
  return arrow;
};

export const getStrengthTierStyle = (tier) => {
  if (tier === 'LEADER') return { bg: alpha('#10b981', 0.12), color: '#10b981' };
  if (tier === 'EMERGING') return { bg: alpha('#3b82f6', 0.12), color: '#3b82f6' };
  return { bg: alpha('#f59e0b', 0.12), color: '#f59e0b' };
};

export const getSmartMoneyStyle = (label) => {
  if (['STRONG_BUY', 'BUY'].includes(label)) return { bg: alpha('#10b981', 0.12), color: '#10b981' };
  if (label === 'WATCH') return { bg: alpha('#f59e0b', 0.12), color: '#d97706' };
  return { bg: alpha('#ef4444', 0.12), color: '#ef4444' };
};

export const formatSignedPercent = (value, digits = 2) => {
  if (value == null) return '—';
  const prefix = value > 0 ? '+' : '';
  return `${prefix}${Number(value).toFixed(digits)}%`;
};

export const formatConvictionTooltip = (value) => {
  const prefix = value > 0 ? '+' : '';
  return `Điểm xác tín: ${prefix}${fmtDec(value)} / 50`;
};

export const formatAvgVolumeTitle = (t, avgVolume, avgValue20d) => {
  const parts = [`${t('behavior.drawer.avg20Vol')}: ${formatCompactVolume(avgVolume)}`];
  if (avgValue20d) parts.push(`${(avgValue20d / 1e9).toFixed(1)} tỷ`);
  return parts.join(' · ');
};

export const formatDrawerScoreChipLabel = (t, titleKey, levelKey) => {
  const levelLabel = t(`behavior.drawer.scoreLevels.${levelKey}`);
  return `${t(titleKey)} ${levelLabel}`;
};

export const formatDrawerMoneyFlowLabel = (t, moneyFlowLabel) => {
  const flowKey = `behavior.flowLabels.${getMoneyFlowKey(moneyFlowLabel)}`;
  return `${t('behavior.drawer.moneyFlow')}: ${t(flowKey, { defaultValue: moneyFlowLabel })}`;
};

export const formatLabelMixTooltip = (t, labelKey, count, widthPct) => {
  const title = t(`behavior.labels.${labelKey}.title`);
  const sessionsUnit = t('behavior.drawer.sessionsUnit');
  return `${title}: ${count} ${sessionsUnit} (${fmtDec(widthPct, 0)}%)`;
};

export const getDrawerScoreLevel = (value) => {
  if (value == null) return null;
  if (value >= 65) return { key: 'strong', color: '#10b981' };
  if (value >= 40) return { key: 'good', color: '#3b82f6' };
  return { key: 'weak', color: '#94a3b8' };
};

export const getHistoryChartLegendLabels = (historyChartData) => (
  HISTORY_CHART_LEGEND_ORDER.filter((label) => historyChartData.some((point) => point.behaviorLabel === label))
);

export const filterScores = (scores, filter, search) => {
  const normalizedSearch = search.toLowerCase();
  return scores.filter((score) => {
    if (filter !== 'ALL' && score.behavior_label !== filter) return false;
    if (search && !score.ticker.toLowerCase().includes(normalizedSearch)) return false;
    return true;
  });
};

export const executeBehaviorCalculation = async ({ setCalculating, setError, fetchData, t }) => {
  setCalculating(true);
  setError(null);
  try {
    await behaviorAPI.calculate();
    await fetchData();
  } catch (e) {
    setError(e.message || t('behavior.calcFailed'));
  } finally {
    setCalculating(false);
  }
};

export const fetchTickerHistory = async ({ ticker, setDrawerTicker, setHistoryLoading, setTickerHistory }) => {
  setDrawerTicker(ticker);
  setHistoryLoading(true);
  setTickerHistory(null);
  try {
    const data = await behaviorAPI.getTickerHistory(ticker, 60);
    setTickerHistory(data);
  } catch (e) {
    setTickerHistory({ error: e.message });
  } finally {
    setHistoryLoading(false);
  }
};

export const exportDrawerSnapshot = async ({ drawerExportRef, drawerBodyRef, exportingDrawer, setExportingDrawer, drawerTicker, tickerHistory }) => {
  const wrapper = drawerExportRef.current;
  const body = drawerBodyRef.current;
  if (!wrapper || exportingDrawer) return;
  const savedWrapperHeight = wrapper.style.height;
  const savedBodyOverflow = body ? body.style.overflowY : '';
  const savedBodyMaxHeight = body ? body.style.maxHeight : '';
  const savedBodyHeight = body ? body.style.height : '';
  try {
    setExportingDrawer(true);
    wrapper.style.height = 'auto';
    if (body) {
      body.style.overflowY = 'visible';
      body.style.maxHeight = 'none';
      body.style.height = 'auto';
    }
    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    const canvas = await html2canvas(wrapper, {
      backgroundColor: '#ffffff',
      scale: 2,
      useCORS: true,
      windowHeight: wrapper.scrollHeight,
    });
    const link = document.createElement('a');
    const ticker = drawerTicker || 'ticker';
    const asOf = tickerHistory?.snapshot?.trade_date || tickerHistory?.history?.[0]?.trade_date || new Date().toISOString().slice(0, 10);
    link.download = `behavior-${ticker}-${asOf}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  } finally {
    wrapper.style.height = savedWrapperHeight;
    if (body) {
      body.style.overflowY = savedBodyOverflow;
      body.style.maxHeight = savedBodyMaxHeight;
      body.style.height = savedBodyHeight;
    }
    setExportingDrawer(false);
  }
};

export const exportWatchlistSnapshot = async ({ watchlistExportRef, exportingWatchlistImage, watchlistLength, summaryTradeDate, setExportingWatchlistImage, setError, t }) => {
  if (!watchlistExportRef.current || exportingWatchlistImage || watchlistLength === 0) return;
  try {
    setExportingWatchlistImage(true);
    const canvas = await html2canvas(watchlistExportRef.current, {
      backgroundColor: '#ffffff',
      scale: 2,
      useCORS: true,
    });
    const link = document.createElement('a');
    const asOfDate = summaryTradeDate || new Date().toISOString().slice(0, 10);
    link.download = `behavior-watchlist-${asOfDate}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  } catch (e) {
    setError(e.message || t('behavior.watchlist.exportFailed'));
  } finally {
    setExportingWatchlistImage(false);
  }
};

export const getTransitionAccent = (isUp, isDown) => {
  if (isUp) return '#10b981';
  if (isDown) return '#ef4444';
  return '#64748b';
};

export const getLevel = (val) => {
  if (val >= 35) return { key: 'high', color: '#10b981' };
  if (val >= 15) return { key: 'mid', color: '#f59e0b' };
  return { key: 'low', color: '#94a3b8' };
};

export const scoreDot = (val, color, t) => {
  const lvl = getLevel(val);
  return (
    <div title={fmtDec(val, 0)}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, cursor: 'default' }}>
        <div style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: color, opacity: val < 15 ? 0.35 : 0.9, flexShrink: 0 }} />
        <span style={{ fontSize: '0.65rem', fontWeight: 700, color: lvl.color, whiteSpace: 'nowrap' }}>
          {t(`behavior.levels.${lvl.key}`)}
        </span>
      </div>
    </div>
  );
};

export const getSkeletonToggleBorderRadius = (index, lastIndex) => {
  if (index === 0) return '4px 0 0 4px';
  if (index === lastIndex) return '0 4px 4px 0';
  return '0';
};

export const getSkeletonToggleMarginLeft = (index) => {
  if (index > 0) return '-1px';
  return '0px';
};
